function showHiddenDonationFields() {
  // Show any hidden fields (e.g. Gift Aid fieldset)
  document
    .querySelectorAll(".crm-profile-name-Gift_Aid")
    .forEach(function (el) {
      el.style.display = "block";
    });

  // Show the priceset div
  let pricesetDiv = document.getElementById("priceset");
  if (pricesetDiv) {
    pricesetDiv.style.display = "block";
  }

  let showRecurSection = document.querySelector(".is_recur-section");
  if (showRecurSection) {
    showRecurSection.style.display = "block";
  }

  // Remove the standfirst paragraph
  let standfirst = document.querySelector(".donate-form-standfirst");
  if (standfirst) {
    standfirst.remove();
  }
}

function redirectDonationEntry(formData) {
  let amount,
    frequency = formData.frequency,
    giftAid = formData.gift_aid_ask,
    redirectUrl;

  switch (frequency) {
    case "monthly":
      redirectUrl = "/civicrm/contribute/transact?reset=1&id=7";
      if (formData["amount_if_regular[radios]"] == "_other_") {
        amount = formData["amount_if_regular[other]"];
      } else if (formData["amount_if_regular[radios]"] != "") {
        amount = formData["amount_if_regular[radios]"];
      }
      break;
    case "once":
    default:
      redirectUrl = "/civicrm/contribute/transact?reset=1&id=2";
      if (formData["amount_if_one_off[radios]"] == "_other_") {
        amount = formData["amount_if_one_off[other]"];
      } else if (formData["amount_if_one_off[radios]"] != "") {
        amount = formData["amount_if_one_off[radios]"];
      }
      break;
  }

  // If amount is set append it as a query param
  if (amount) {
    redirectUrl += `&donation_amount=${encodeURIComponent(amount)}`;
  }

  redirectUrl += `&gift_aid=${encodeURIComponent(giftAid)}`;

  // console.log("[donation-widget] redirecting to:", redirectUrl);

  // Redirect to the constructed URL
  window.location.href = redirectUrl;
}

/**
 * Reads the widget form's own GET params off the current URL and rebuilds the same key
 * shape that used to come from FormData, e.g. "amount_if_one_off[radios]".
 *
 * Returns null if this doesn't look like a genuine widget submission.
 */
function getWidgetFormDataFromUrl() {
  let urlParams = new URLSearchParams(window.location.search);

  // Bail unless this looks like an actual submission of the widget form
  if (!urlParams.has("frequency") || urlParams.get("op") !== "Next") {
    return null;
  }

  let formData = {};
  for (const [key, value] of urlParams.entries()) {
    formData[key] = value;
  }

  // console.log("[donation-widget] Parsed formData from URL:", formData);

  return formData;
}

function shouldPreFillCiviForm() {
  let urlParams = new URLSearchParams(window.location.search);

  let didMatchGiftAid,
    didMatchAmount,
    otherAmountField,
    otherAmountTextField,
    didGiftAid;

  let formId = null;
  if (urlParams.has("id")) {
    formId = urlParams.get("id");
  }

  // Bail if no form ID
  if (!formId) {
    return;
  }

  switch (formId) {
    case "7":
      // Monthly
      otherAmountField = "#CIVICRM_QFID_0_price_111";
      otherAmountTextField = "#price_112";

      // Make sure that '#is_recur' checkbox is checked
      let isRecurCheckbox = document.getElementById("is_recur");
      if (isRecurCheckbox) {
        isRecurCheckbox.checked = true;
      }
      break;
    case "2":
    default:
      // Single
      otherAmountField = "#CIVICRM_QFID_0_price_6";
      otherAmountTextField = "#price_7";
      break;
  }

  if (urlParams.has("donation_amount")) {
    let donationAmount = urlParams.get("donation_amount");

    // See if the donationAmount matches any input in #priceset-div, if so we can check that input
    let amountInputs = document.querySelectorAll(`#priceset-div input`);

    let matched = false;
    amountInputs.forEach(function (input) {
      let optionAmount = input.getAttribute("data-amount");
      if (optionAmount === donationAmount) {
        input.checked = true;
        matched = true;
        didMatchAmount = true;

        // SIMULATE A CHANGE EVENT / CLICK on the input
        input.click();
      }
    });

    // no options were matched, so we need to fill in the "Other" field
    if (!matched) {
      let otherAmountRadio = document.querySelector(otherAmountField);
      let otherAmountTextInput = document.querySelector(otherAmountTextField);

      if (otherAmountRadio && otherAmountTextInput) {
        otherAmountRadio.checked = true;
        didMatchAmount = true;

        // SIMULATE A CHANGE EVENT / CLICK on the radio and an input event on the text input
        otherAmountRadio.click();

        setTimeout(function () {
          otherAmountTextInput.value = donationAmount;
          otherAmountTextInput.dispatchEvent(
            new Event("input", { bubbles: true }),
          );
          otherAmountTextInput.dispatchEvent(
            new Event("change", { bubbles: true }),
          );
          otherAmountTextInput.focus();
          otherAmountTextInput.dispatchEvent(
            new Event("blur", { bubbles: true }),
          );
        }, 100);
      }
    }
  }

  // Set the #priceset display none
  if (didMatchAmount) {
    let pricesetDiv = document.getElementById("priceset");
    if (pricesetDiv) {
      pricesetDiv.style.display = "none";
    }

    // Also hide .is_recur-section if it exists
    let isRecurSection = document.querySelector(".is_recur-section");
    if (isRecurSection) {
      isRecurSection.style.display = "none";
    }
  }

  if (urlParams.has("gift_aid")) {
    let fieldsetWrapper = document.querySelector(".crm-profile-name-Gift_Aid");

    if (fieldsetWrapper) {
      let giftAidValue = urlParams.get("gift_aid");

      // Find the .crm-form-radio that has the value matching giftAidValue
      let giftAidOptions = fieldsetWrapper.querySelectorAll(".crm-form-radio");
      giftAidOptions.forEach(function (option) {
        if (option && option.value === giftAidValue) {
          option.checked = true;
          didMatchGiftAid = true;

          // Get the label, its the next element sibling
          let label = option.nextElementSibling;
          // console.log("Found matching GAD option:", option, label);

          if (label && label.innerText.includes("Yes")) {
            didGiftAid = true;
          }

          // Hide the GAD Fieldset and break out of the loop
          fieldsetWrapper.style.display = "none";

          return;
        }
      });
    }
  }

  if (didGiftAid) {
    didGiftAid = "You chose to add Gift Aid.";
  } else {
    didGiftAid = "You chose not to add Gift Aid.";
  }

  if (didMatchAmount) {
    outputAmount =
      "Thankyou for choosing to donate £" + urlParams.get("donation_amount");
    if (formId === "7") {
      outputAmount += " monthly";
    }

    outputAmount += ".";
  } else {
    outputAmount = "";
  }

  // Build up markup to indicate what has been pre-filled
  let markup = `<p class='donate-form-standfirst'>${outputAmount} ${didGiftAid} <a href="javascript:showHiddenDonationFields()">Not right? Change something.</a></p>`;

  // Add the markup as the first child of #priceset-div
  let pricesetDiv = document.getElementById("priceset-div");
  if (pricesetDiv && (didMatchAmount || didMatchGiftAid)) {
    pricesetDiv.insertAdjacentHTML("afterbegin", markup);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // If the URL has a donation_amount query param set, add a class of
  // .from-donation-widget to the body (this fires on the CiviCRM
  // transact page, once we've redirected there)
  if (new URLSearchParams(window.location.search).has("donation_amount")) {
    document.body.classList.add("from-donation-widget");
  }

  // Pre-fill the CiviCRM contribute form, if we've landed on it with the
  // relevant query params
  shouldPreFillCiviForm();

  // If we've landed back on the widget form itself via its own GET
  // submission, pull the data straight off the URL and redirect on to
  // the appropriate CiviCRM contribute form
  let widgetFormData = getWidgetFormDataFromUrl();
  if (widgetFormData) {
    // console.log(
    //   "[donation-widget] Widget submission detected - redirecting to CiviCRM form now",
    // );
    redirectDonationEntry(widgetFormData);
    return;
  } else {
    // console.log(
    //   "[donation-widget] No widget submission detected on this page load - continuing normal init",
    // );
  }

  function updateGiftAid(amount) {
    // Determine what radio option is ticked in name="frequency"
    let frequency = document.querySelector(
      'input[name="frequency"]:checked',
    ).value;

    let giftAidAmount = 0;
    if (frequency === "once") {
      frequency = "one-off";
    }

    // If the amount is empty or not a number, set all to £0.00
    if (amount === "" || isNaN(amount)) {
      document.querySelectorAll(".giftaid-amount").forEach(function (el) {
        el.innerText = "£0.00";
      });
      document.querySelectorAll(".giftaid-boost").forEach(function (el) {
        el.innerText = "£0.00";
      });
      return;
    }

    // .giftaid-frequency innerText = frequency
    document.querySelectorAll(".giftaid-frequency").forEach(function (el) {
      el.innerText = frequency;
    });

    // .giftaid-amount innerText = amount
    document.querySelectorAll(".giftaid-amount").forEach(function (el) {
      el.innerText = "£" + amount;
    });

    // Calculate gift aid amount (25% of donation amount)
    giftAidAmount = (parseFloat(amount) * 0.25).toFixed(2);

    // .giftaid-calculated-amount innerText = giftAidAmount
    document.querySelectorAll(".giftaid-boost").forEach(function (el) {
      el.innerText = "£" + (parseFloat(giftAidAmount) + parseFloat(amount));
    });
  }

  let pillOptions = document.querySelectorAll(
    ".pill-options input[type='radio'], .pill-options input[type='checkbox']",
  );
  pillOptions.forEach(function (input) {
    input.addEventListener("change", function () {
      if (input.checked) {
        updateGiftAid(input.value);
      }
    });
  });

  // When keyup in a .js-webform-radios-other-input input, log the value
  let otherInputs = document.querySelectorAll(
    ".js-webform-radios-other-input input",
  );
  otherInputs.forEach(function (input) {
    input.addEventListener("keyup", function () {
      // Remove any non-numeric characters except for dot
      let sanitizedValue = input.value.replace(/[^0-9.]/g, "");
      input.value = sanitizedValue;

      updateGiftAid(sanitizedValue);
    });
  });
});
